/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : authStyle.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 15-06-2024
 * @description Styling for the Authentication component.
 */
const styles = {
    container: {
        backgroundColor: "black",
        position: "relative",
        height: "100vh",
        width: "100vW",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
    },
    bgImgContainer: {
        display: "flex",
        alignItems: { xs: "center", sm: "none" },
        justifyContent: { xs: "center", sm: "none" },
        position: "fixed",
        right: { xs: "0%", sm: "10%", lg: "10%" },
        maxWidth: "100vW",
    },
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: { xm: "none", sm: "360px" },
        left: { md: "20%" },
        zIndex: 100,
        marginLeft: { xs: 0, md: "-50%" },
    },
};

export default styles;